import TextComponent from "@/components/form-control/text.vue";
import DateRange from "@/components/form-control/date-range.vue";
import UploadComponent from "@/components/form-control/upload.vue";
import CostDetails from "@/components/form-control/cost-details.vue";
import ContainerComponent from "@/components/form-control/container.vue";
import { generateMixed } from "@/common/js/utils.js";


/* 表单控件集合 */
const FORM_CONTROL_LIST = [
  {
    title: "文本",
    list: [
      {
        name: "单行文本",
        img: require("../../../assets/form/single-line-text.png"),
        htmlContent: "TextComponent",
        required: true,
        placeholder: '请输入',
        type: 'text',
      },
      {
        name: "多行文本",
        img: require("../../../assets/form/multiline-text.png"),
        htmlContent: "TextComponent",
        required: true,
        placeholder: '请输入',
        type: 'textarea',
      },
    ],
  },
  {
    title: "数值",
    list: [
      {
        name: "数字",
        img: require("../../../assets/form/num.png"),
        htmlContent: "TextComponent",
        required: true,
        placeholder: '请输入',
        type: 'numText'
      },
      {
        name: "金额",
        img: require("../../../assets/form/amount.png"),
        htmlContent: "TextComponent",
        required: true,
        placeholder: '请输入',
        type: 'amountText'
      },
    ],
  },
  {
    title: "选项",
    list: [
      {
        name: "单选",
        img: require("../../../assets/form/radio.png"),
        htmlContent: "TextComponent",
        required: true,
        isSelect: true,
        placeholder: '请选择',
        type: 'radio'
      },
    ],
  },
  {
    title: "日期",
    list: [
      {
        name: "日期",
        img: require("../../../assets/form/date.png"),
        htmlContent: "TextComponent",
        required: true,
        isSelect: true,
        placeholder: '请选择',
        type: 'date'
      },
      {
        name: "日期区间",
        img: require("../../../assets/form/date-range.png"),
        htmlContent: "DateRange",
        required: true,
        type: 'dateRange',
        placeholder: '请选择',
        startTime: '开始日期',
        endTime: '结束日期',
        durationTime: '时长（天）',
      },
    ],
  },
  {
    title: "其他",
    list: [
      // {
      //   name: "容器",
      //   img: require("../../../assets/form/container.png"),
      //   htmlContent: "ContainerComponent",
      //   required: true,
      //   type: 'container'
      // },
      {
        name: "图片",
        img: require("../../../assets/form/img.png"),
        htmlContent: "UploadComponent",
        required: true,
        type: 'img'
      },
      {
        name: "附件",
        img: require("../../../assets/form/enclosure.png"),
        htmlContent: "UploadComponent",
        required: true,
        type: 'enclosure'
      },
      {
        name: "地址",
        img: require("../../../assets/form/address.png"),
        htmlContent: "TextComponent",
        required: true,
        isSelect: true,
        placeholder: '请选择',
        type: 'addressSelect'
      },
      {
        name: "经办人",
        img: require("../../../assets/form/agent.png"),
        htmlContent: "TextComponent",
        required: false,
        placeholder: '系统自动获取',
        type: 'agentText'
      },
      {
        name: "职、级别",
        img: require("../../../assets/form/level.png"),
        htmlContent: "TextComponent",
        required: false,
        placeholder: '系统自动获取',
        type: 'levelText'
      },
      // {
      //   name: "费用明细",
      //   img: require("../../../assets/form/cost.png"),
      //   htmlContent: "CostDetails",
      //   required: true,
      //   type: 'cost'
      // },
    ],
  },
]

export const formControlMixins = {
  components: {
    TextComponent,
    DateRange,
    UploadComponent,
    CostDetails,
    ContainerComponent
  },
  data() {
    return {
      FORM_CONTROL_LIST,
    }
  }
}